import { render } from "./MantenimientoCard.vue?vue&type=template&id=60eb3c90&scoped=true"
import script from "./MantenimientoCard.vue?vue&type=script&lang=js"
export * from "./MantenimientoCard.vue?vue&type=script&lang=js"

import "./MantenimientoCard.vue?vue&type=style&index=0&id=60eb3c90&lang=sass&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60eb3c90"]])

export default __exports__